import * as Types from '../constants/Types';

export const dataBannerAction = (filters) => ({type: Types.BANNER_LIST_ACTION, filters});
export const dataBannerSuccess = (banners) => ({type: Types.BANNER_LIST_SUCCESS, banners});

export const createBannerAction = (params) => ({type: Types.BANNER_CREATE_ACTION, params});
export const deleteBannerAction = (params) => ({type: Types.BANNER_DELETE_ACTION, params});

export const getUpdateBannerAction = (params) => ({type: Types.BANNER_GET_UPDATE_ACTION, params});
export const getUpdateBannerSuccess = (dataUpdate) => ({type: Types.BANNER_GET_UPDATE_SUCCESS, dataUpdate});

export const updateBannerAction = (params) => ({type: Types.BANNER_UPDATE_ACTION, params});

export const createBannerTranslate = (banner) => ({type: Types.BANNER_CREATE_TRANSLATE_ACTION, banner});
export const updateBannerTranslate = (banner) => ({type: Types.BANNER_UPDATE_TRANSLATE_ACTION, banner});
export const deleteBannerTranslate = (banner, refreshParams) => ({type: Types.BANNER_DELETE_TRANSLATE_ACTION, banner, refreshParams});